export default function auth({ next, router }) {
    if(router.app.$store && router.app.$store.state.logged) {
        router.push('/')
        return
    }
    return next()
}